module.exports = __webpack_public_path__ + "img/volume.f6e7fa6f.svg";